import { RouteRecordRaw } from 'vue-router';
import { AdminFunctionalActivitiesPage } from '@/pages/admin';

export const routeName = 'AdminAtividadesFuncionais';

export const route: RouteRecordRaw = {
  path: 'atividades-funcionais',
  name: routeName,
  component: AdminFunctionalActivitiesPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Atividades Funcionais',
    permissions: [{ action: 'read', subject: 'Admin' }],
  },
};
